// extracted by mini-css-extract-plugin
export default {"spin":"spin-eXHVi","deep":"deep-tWbKb","light":"light-w0MqQ","left2right":"left2right-NWHmO","right2left":"right2left-lgx99","desc":"desc-zs4R9"};